import { render } from "./Topup2c2pList.vue?vue&type=template&id=3cb3bd8a&scoped=true"
import script from "./Topup2c2pList.vue?vue&type=script&lang=js"
export * from "./Topup2c2pList.vue?vue&type=script&lang=js"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb3bd8a"]])

export default __exports__